"use client";

import { useContext } from "react";

import clsx from "clsx";
import { useParams, usePathname } from "next/navigation";

import { useTranslation } from "~/app/hooks/useTranslation";
import { resolveInternalPath, splitLocaleFromPathname } from "~/app/lib/routeUtils";
import hero1 from "~/assets/images/helpCenter/hero1.svg?url";
import SearchIconSvg from "~/assets/images/helpCenter/search-icon.svg";
import Input from "~/common/components/Input";

import Breadcrumb from "../../../common/components/Breadcrumb";
import SectionWrapper from "../../../common/components/SectionWrapper";

import { HelpCenterContext } from "./context";
import styles from "./page.module.scss";

export default function SearchSection({}) {
  const ctx = useContext(HelpCenterContext);
  const searchText = ctx.searchState.value;
  const handleChange = (e) => {
    const { value } = e.target;
    ctx.searchState.onChange(value);
  };
  const { locale } = useParams();
  const pathname = usePathname();
  const { pathname: pathWithoutLocale } = splitLocaleFromPathname(pathname);
  const publicPathKey = pathWithoutLocale === "/" ? "" : pathWithoutLocale.replace(/^\//, "");
  const { path: internalPath } = resolveInternalPath(locale, publicPathKey);
  const segments = internalPath ? internalPath.split("/") : [];
  const isMainPage = internalPath === "help-center";

  // If the path is exactly "/help-center", we consider it the main page
  const { t } = useTranslation();
  return (
    <SectionWrapper
      className={clsx({
        [styles.section1]: true,
        [styles.section1Main]: isMainPage,
        [styles.section1Sub]: !isMainPage,
      })}
      background={hero1}
    >
      <div
        className={clsx({
          [styles.searchSection]: true,
          card: true,
          [styles.searchSectionSub]: !isMainPage,
        })}
      >
        {!isMainPage && (
          <div className={styles.breadcrumbWrapper}>
            <Breadcrumb sections={ctx.faqSections} />
          </div>
        )}
        <h1 title={isMainPage ? t("helpCenter.searchSection.title") : t(ctx.faqSections[segments[1]])}>{isMainPage ? t("helpCenter.searchSection.title") : t(ctx.faqSections[segments[1]])}</h1>
        <p>{t("helpCenter.searchSection.description")}</p>
        <Input
          icon={SearchIconSvg}
          id="search"
          name="search"
          label={t("helpCenter.searchSection.searchLabel")}
          type="search"
          className={styles.searchInput}
          value={searchText}
          onChange={handleChange}
        />
      </div>
    </SectionWrapper>
  );
}
